import * as React from 'react';
import { IDepot } from '../models';
import { useData } from '../core/context/ProvidersContext';

export function useDepots(): {
  depots: IDepot[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
} {
  const data = useData();
  const [depots, setDepots] = React.useState<IDepot[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  const refresh = React.useCallback(() => {
    setLoading(true);
    setError(null);
    data.getDepots()
      .then(setDepots)
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  }, [data]);

  React.useEffect(() => { refresh(); }, [refresh]);

  return { depots, loading, error, refresh };
}
